import { Icons } from "./icons";
import React, { useEffect, useState } from "react";
import { db, auth } from "./firebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import { collection, getDocs, doc, getDoc, setDoc, updateDoc, deleteDoc, onSnapshot } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import "./Dashboard.css";

const C = {
  bg: "#0a0a0f", bg2: "#111118",
  surface: "rgba(255,255,255,0.04)", surfaceHover: "rgba(255,255,255,0.07)",
  border: "rgba(255,255,255,0.08)", borderHover: "rgba(255,255,255,0.13)",
  text: "#f5f5f7", secondary: "rgba(245,245,247,0.55)", tertiary: "rgba(245,245,247,0.30)",
  accent: "#0a84ff", green: "#30d158", greenBg: "rgba(48,209,88,0.1)",
  orange: "#ff9f0a", purple: "#bf5af2", red: "#ff453a",
};

const inp = {
  width: "100%", padding: "0.62rem 0.8rem",
  background: "rgba(255,255,255,0.05)",
  border: "1px solid rgba(255,255,255,0.09)",
  borderRadius: 10, color: C.text,
  fontSize: "0.82rem", boxSizing: "border-box",
  outline: "none", fontFamily: "inherit",
};

// ─── Small reusable pieces ────────────────────────────────────────────────────
function Lbl({ children }) {
  return <label style={{ display: "block", marginBottom: "0.3rem", fontSize: "0.7rem", color: C.secondary, fontWeight: 500 }}>{children}</label>;
}

function ActionBtn({ children, onClick, color = C.accent, full = false }) {
  return (
    <button onClick={onClick} style={{
      padding: "0.55rem 0.9rem", background: color + "15",
      border: `1px solid ${color}30`, borderRadius: 10,
      color: C.text, fontSize: "0.77rem", fontWeight: 600,
      cursor: "pointer", width: full ? "100%" : "auto",
      transition: "background 160ms ease", fontFamily: "inherit",
    }}
      onMouseEnter={e => e.currentTarget.style.background = color + "28"}
      onMouseLeave={e => e.currentTarget.style.background = color + "15"}
    >{children}</button>
  );
}

function Toggle({ icon, label, active, onClick }) {
  return (
    <button onClick={onClick} style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      width: "100%", padding: "0.7rem 0.9rem",
      background: C.surface, border: `1px solid ${C.border}`,
      borderRadius: 12, cursor: "pointer", color: C.text,
      fontSize: "0.8rem", fontWeight: 500,
      transition: "background 150ms ease", fontFamily: "inherit",
    }}
      onMouseEnter={e => e.currentTarget.style.background = C.surfaceHover}
      onMouseLeave={e => e.currentTarget.style.background = C.surface}
    >
      {(() => { const Icon = Icons[icon]; return (
        <span style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          {Icon && <Icon color="#0a84ff" />}
          {label}
        </span>
      ); })()}
      <span style={{
        fontSize: "0.62rem", fontWeight: 700, letterSpacing: "0.5px",
        padding: "2px 8px", borderRadius: 6,
        color: active ? C.green : C.red,
        background: active ? C.greenBg : C.red + "18",
        border: `1px solid ${active ? C.green + "33" : C.red + "33"}`,
      }}>{active ? "ON" : "OFF"}</span>
    </button>
  );
}

function Modal({ onClose, title, children }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.72)", backdropFilter: "blur(10px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000001, padding: "1rem" }}
      onClick={onClose}>
      <div style={{ background: "#1c1c1e", border: `1px solid ${C.border}`, borderRadius: 24, padding: "1.5rem 1.6rem", maxWidth: 500, width: "100%", maxHeight: "88vh", overflowY: "auto", boxShadow: "0 24px 64px rgba(0,0,0,0.65)", touchAction: "pan-y" }}
        onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 700, color: C.text }}>{title}</h3>
          <button onClick={onClose} style={{ background: C.surface, border: "none", borderRadius: "50%", width: 30, height: 30, color: C.secondary, fontSize: "1rem", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "inherit" }}>
            <Icons.eyeOff />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

function ColorField({ label, hint, val, onChange }) {
  return (
    <div style={{ marginBottom: "1rem" }}>
      <Lbl>{label} {hint && <span style={{ color: C.tertiary, fontWeight: 400 }}>— {hint}</span>}</Lbl>
      <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
        <input type="color" value={val} onChange={e => onChange(e.target.value)}
          style={{ width: 38, height: 34, border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, cursor: "pointer", background: "transparent", padding: 0, flexShrink: 0 }} />
        <input type="text" value={val} onChange={e => onChange(e.target.value)}
          style={{ ...inp, flex: 1, fontFamily: "monospace" }}
          onFocus={e => e.target.style.borderColor = C.accent + "88"}
          onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.09)"}
        />
      </div>
    </div>
  );
}

// ─── Main ─────────────────────────────────────────────────────────────────────
export default function VisualizzaLocali() {
  const [locali, setLocali] = useState([]);
  const [search, setSearch] = useState("");
  const [modifiche, setModifiche] = useState({});
  const [messaggio, setMessaggio] = useState("");
  const [modaleAperta, setModaleAperta] = useState(null);
  const [modaleColoriAperta, setModaleColoriAperta] = useState(null);
  const [coloriTemp, setColoriTemp] = useState({});
  const [modaleAIOpen, setModaleAIOpen] = useState(null);
  const [newAiCredits, setNewAiCredits] = useState(0);
  const [aiEnabled, setAiEnabled] = useState(false);
  const [aiCredits, setAiCredits] = useState(0);
  const [translationCredits, setTranslationCredits] = useState(0);
  const [translationEnabled, setTranslationEnabled] = useState(false);
  const [limitePiatti, setLimitePiatti] = useState("");
const [limiteCamerieri, setLimiteCamerieri] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(u => { if (!u) navigate("/login"); });
    return () => unsub();
  }, [navigate]);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "locali"), (snap) => {
      setLocali(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  const loadAITranslations = async (id) => {
    const snap = await getDoc(doc(db, "restaurants", id, "ai", "translations"));
    if (snap.exists()) { const d = snap.data(); setTranslationCredits(d.translationCredits || 0); setTranslationEnabled(d.enabled === true); }
    else { setTranslationCredits(0); setTranslationEnabled(false); }
  };

  useEffect(() => {
    if (!modaleAIOpen) return;
    const load = async () => {
      const snap = await getDoc(doc(db, "aiCredits", modaleAIOpen));
      if (snap.exists()) { const d = snap.data(); setAiCredits(d.credits || 0); setNewAiCredits(d.credits || 0); setAiEnabled(d.enabled !== false); }
      else { setAiCredits(0); setNewAiCredits(50); setAiEnabled(false); }
      await loadAITranslations(modaleAIOpen);
    };
    load();
  }, [modaleAIOpen]);

  useEffect(() => {
  if (!modaleAperta) return;

  const locale = locali.find(l => l.id === modaleAperta);
  if (!locale) return;

  setLimitePiatti(
    locale.limitePiatti === null || locale.limitePiatti === undefined
      ? ""
      : String(locale.limitePiatti)
  );

  setLimiteCamerieri(
    locale.limiteCamerieri === null || locale.limiteCamerieri === undefined
      ? ""
      : String(locale.limiteCamerieri)
  );
}, [modaleAperta, locali]);

  const handleChange = (id, field, value) => {
    setModifiche(prev => ({ ...prev, [id]: { ...prev[id], [field]: value, ...(field === "logoFile" && { anteprima: value ? URL.createObjectURL(value) : null }) } }));
  };

  const salvaModifiche = async (id) => {
    const dati = modifiche[id]; const locale = locali.find(l => l.id === id);
    if (!dati || !locale) { setMessaggio("❌ Dati mancanti."); return; }
    const tavoliFinali = dati.tavoli ?? locale.numeroTavoli ?? locale.tavoli;
    if (isNaN(tavoliFinali) || tavoliFinali <= 0) { setMessaggio("⚠️ Numero tavoli non valido."); return; }
    const saleFinali = dati.sale !== undefined ? dati.sale : (locale.sale || []);
    let logoUrl = locale.logoUrl || "";
    if (dati.logoFile) {
      try { const sRef = ref(getStorage(), `public/loghiLocali/${id}.png`); await uploadBytes(sRef, dati.logoFile); logoUrl = await getDownloadURL(sRef); }
      catch { setMessaggio("❌ Errore upload logo."); return; }
    }
    const nuovoTag = dati.nuovoTag?.trim();
    const tagFinale = nuovoTag && nuovoTag !== id ? nuovoTag : id;
    try {
      if (tagFinale !== id) {
        const esiste = await getDoc(doc(db, "locali", tagFinale));
        if (esiste.exists()) { setMessaggio(`⚠️ Tag "${tagFinale}" già in uso.`); return; }
        const snap = await getDoc(doc(db, "locali", id));
        if (snap.exists()) {
          await setDoc(doc(db, "locali", tagFinale), { ...snap.data(), logoUrl, numeroTavoli: tavoliFinali, sale: saleFinali });
          // 🔥 elimina vecchi tavoli prima del rename
const tavoliSnap = await getDocs(
  collection(db, "locali", id, "tavoli")
);

for (const d of tavoliSnap.docs) {
  await deleteDoc(d.ref);
}
          await deleteDoc(doc(db, "locali", id));
          await uploadBytes(ref(getStorage(), `public/loghiLocali/${tagFinale}.png`), dati.logoFile);
          await deleteObject(ref(getStorage(), `public/loghiLocali/${id}.png`)).catch(() => {});
          setLocali(prev => prev.map(l => l.id === id ? { ...snap.data(), id: tagFinale, logoUrl, numeroTavoli: tavoliFinali, sale: saleFinali } : l));
          setMessaggio(`✅ Tag aggiornato: "${tagFinale}"`);
        }
      } else {
        await updateDoc(doc(db, "locali", id), { logoUrl, numeroTavoli: tavoliFinali, sale: saleFinali });
        setMessaggio(`✅ Locale "${id}" aggiornato.`);
      }
    } catch { setMessaggio("❌ Errore nel salvataggio."); }
    setTimeout(() => setMessaggio(""), 4000);
  };


  const toggleImpostazioneLocale = async (id, campo) => {
    const locale = locali.find(l => l.id === id);
    if (!locale) return;

    const valoreAttuale = locale[campo] === true;
    const nuovoValore = !valoreAttuale;


    try {
      const updateData = {
        [campo]: nuovoValore
      };

      // 🔥 compatibilità vecchio refuso Lingue
      if (campo === "mostraSelezioneLingue") {
        updateData.mostraSelezioneLinque = nuovoValore;
      }

      await updateDoc(doc(db, "locali", id), updateData);

      setLocali(prev =>
        prev.map(l =>
          l.id === id
            ? {
                ...l,
                [campo]: nuovoValore,
                ...(campo === "mostraSelezioneLingue"
                  ? { mostraSelezioneLinque: nuovoValore }
                  : {})
              }
            : l
        )
      );

      setMessaggio(`✅ "${campo}" ${nuovoValore ? "attivato" : "disattivato"}`);
      setTimeout(() => setMessaggio(""), 3000);
    } catch {
      setMessaggio("❌ Errore aggiornamento.");
    }
  };

  const toggleStatoLocale = async (id) => {
    const locale = locali.find(l => l.id === id);
    if (!locale) return;

    const nuovoStato = locale.stato === "bloccato" ? "attivo" : "bloccato";

    try {
      await updateDoc(doc(db, "locali", id), { stato: nuovoStato });

      setLocali(prev =>
        prev.map(l =>
          l.id === id ? { ...l, stato: nuovoStato } : l
        )
      );

      setMessaggio(
        nuovoStato === "bloccato"
          ? "🚫 Locale bloccato"
          : "✅ Locale riattivato"
      );

      setTimeout(() => setMessaggio(""), 3000);
    } catch {
      setMessaggio("❌ Errore aggiornamento stato.");
    }
  };

const eliminaLocale = async (id) => {

  const ok = window.confirm(
    `Eliminare completamente "${id}"?\n\n` +
    `Verranno eliminati:\n` +
    `• locale\n` +
    `• tavoli\n` +
    `• demoLeads\n` +
    `• autenticazione utente\n` +
    `• crediti AI\n` +
    `• logo`
  );

  if (!ok) return;

  try {

    setMessaggio("⏳ Eliminazione in corso...");

    // 🔥 cloud function admin
    const functions = getFunctions(
      undefined,
      "europe-west1"
    );

    const deleteDemoAccount = httpsCallable(
      functions,
      "deleteDemoAccount"
    );

    await deleteDemoAccount({
      localeTag: id
    });

    setLocali(prev =>
      prev.filter(l => l.id !== id)
    );

    setMessaggio(
      `✅ Locale "${id}" eliminato`
    );

  } catch (e) {

    console.error(e);

    setMessaggio(
      "❌ Errore eliminazione completa."
    );

  }

  setTimeout(() => {
    setMessaggio("");
  }, 4000);

};

  const apriModaleColori = (id) => {
    const locale = locali.find(l => l.id === id);
    setColoriTemp(locale?.colori || { primario: "#3E2723", secondario: "#8B4513", sfondo: "#FAEBD7", testo: "#3E2723" });
    setModaleColoriAperta(id);
  };

  const salvaColori = async (id) => {
    try { await updateDoc(doc(db, "locali", id), { colori: coloriTemp }); setLocali(prev => prev.map(l => l.id === id ? { ...l, colori: coloriTemp } : l)); setModaleColoriAperta(null); setMessaggio(`✅ Colori aggiornati.`); setTimeout(() => setMessaggio(""), 3000); }
    catch { setMessaggio("❌ Errore colori."); }
  };

  const resetColori = async (id) => {
    const def = { primario: "#3E2723", secondario: "#8B4513", sfondo: "#FAEBD7", testo: "#3E2723" };
    try { await updateDoc(doc(db, "locali", id), { colori: def }); setLocali(prev => prev.map(l => l.id === id ? { ...l, colori: def } : l)); setModaleColoriAperta(null); setMessaggio(`✅ Colori ripristinati.`); setTimeout(() => setMessaggio(""), 3000); }
    catch { setMessaggio("❌ Errore reset."); }
  };

  const TOGGLES = [
    { key: "nascondiStatoTavoli", icon: "table", label: "Stato tavoli", invertito: true },
    { key: "nascondiModificaMenu", icon: "menu", label: "Modifica menu", invertito: true },
    { key: "nascondiOrdini", icon: "ordini", label: "Ordini", invertito: true },
    { key: "nascondiCucina", icon: "kitchen", label: "Cucina", invertito: true },
    { key: "nascondiCassa", icon: "cassa", label: "Cassa", invertito: true },
    { key: "nascondiAsporto", icon: "qr", label: "Asporto", invertito: true },
    { key: "nascondiCamerieri", icon: "users", label: "Camerieri", invertito: true },
    { key: "nascondiReport", icon: "table", label: "Report", invertito: true },
    { key: "nascondiPromozioni", icon: "tag", label: "Promozioni", invertito: true },
    { key: "nascondiBannerPromozionali", icon: "category", label: "Banner", invertito: true },
    { key: "consentOrdine", icon: "ordini", label: "Consenti ordine", invertito: false },
    { key: "consentChiamataCameriere", icon: "bell", label: "Chiamata cameriere", invertito: false },
    { key: "mostraSelezioneLingue", icon: "category", label: "Lingue", invertito: false },
    { key: "stampaAutomaticaOrdini", icon: "print", label: "Stampa automatica", invertito: false },
    // 🔥 NUOVO
    { key: "nascondiAI", icon: "ai", label: "Assistente AI", invertito: true },
    { key: "menuConFoto", icon: "category", label: "📷 Foto nel menu (clienti)", invertito: false },
    { key: "adminMenuConFoto", icon: "category", label: "📷 Foto nel menu (pulsante editor)", invertito: false },
    { key: "suggerimentiAI", icon: "ai", label: "✨ Suggerimenti inline (clienti)", invertito: false },
    { key: "adminSuggerimentiAI", icon: "ai", label: "✨ Suggerimenti inline (pulsante editor)", invertito: false },
  ];

  const filtered = locali.filter(l => {
    const v = search.trim().toLowerCase();
    return !v || (l.nome || "").toLowerCase().startsWith(v) || l.id.toLowerCase().startsWith(v);
  });

  const toastColor = messaggio.startsWith("✅") ? C.green : messaggio.startsWith("❌") ? C.red : C.orange;

  return (
    <div style={{ minHeight: "100vh", background: C.bg, fontFamily: "-apple-system, 'SF Pro Display', 'Helvetica Neue', sans-serif", color: C.text }}>
      <Navbar />
      <div className="page-with-navbar" style={{ maxWidth: 960, margin: "0 auto" }}>

        {/* Header */}
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: "0.75rem", marginBottom: "1.75rem" }}>
          <div>
            <p style={{ margin: "0 0 0.25rem", fontSize: "0.75rem", color: C.secondary, fontWeight: 500 }}>Amministrazione</p>
            <h1 style={{ margin: 0, fontSize: "clamp(1.4rem, 3vw, 1.9rem)", fontWeight: 700, letterSpacing: "-0.5px" }}>
              Gestione Locali <span style={{ fontSize: "1rem", color: C.secondary, fontWeight: 500 }}>({filtered.length})</span>
            </h1>
          </div>
          <input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Cerca…"
            style={{ ...inp, width: "auto", minWidth: 170 }}
            onFocus={e => e.target.style.borderColor = C.accent + "88"}
            onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.09)"}
          />
        </div>

        {/* Toast */}
        {messaggio && (
          <div style={{ padding: "0.75rem 1rem", borderRadius: 12, marginBottom: "1rem", fontSize: "0.82rem", fontWeight: 600, background: toastColor + "14", border: `1px solid ${toastColor}30`, color: toastColor }}>
            {messaggio.replace("✅ ", "").replace("❌ ", "").replace("⚠️ ", "")}
          </div>
        )}

        {locali.length === 0 && <p style={{ color: C.tertiary, textAlign: "center", padding: "3rem" }}>Nessun locale trovato.</p>}

        {/* Grid cards */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: "1rem" }}>
          {filtered.map(locale => {
            const mod = modifiche[locale.id] || {};
            const saleCorrente = mod.sale !== undefined ? mod.sale : (locale.sale || []);
            return (
              <div
                key={locale.id}
                style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 22, overflow: "hidden" }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 12px 28px rgba(0,0,0,0.45)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = "";
                  e.currentTarget.style.boxShadow = "";
                }}
              >
                {/* Card top */}
                <div style={{ padding: "1rem 1.1rem", borderBottom: `1px solid ${C.border}`, display: "flex", alignItems: "center", gap: "0.8rem" }}>
                  {(mod.anteprima || locale.logoUrl) && (
                    <img src={mod.anteprima || locale.logoUrl} alt="Logo"
                      style={{ width: 44, height: 44, objectFit: "contain", borderRadius: 10, background: "rgba(255,255,255,0.07)", padding: "0.15rem", flexShrink: 0 }} />
                  )}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ margin: 0, fontSize: "0.95rem", fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{locale.nome || "Senza nome"}</p>
                    <p style={{ margin: "0.1rem 0 0", fontSize: "0.7rem", color: C.secondary }}>
                      {locale.id} · {locale.numeroTavoli || 0} tavoli
                      {locale.modalitaAsporto && <span style={{ color: C.orange }}> · Asporto</span>}
                    </p>
                  </div>
                </div>

                {/* Card body */}
                <div style={{ padding: "1rem 1.1rem" }}>
                  <Lbl>Numero tavoli</Lbl>
                  <input type="number" defaultValue={locale.numeroTavoli || locale.tavoli || 0} min={1}
                    onChange={e => handleChange(locale.id, "tavoli", parseInt(e.target.value))}
                    style={{ ...inp, marginBottom: "0.85rem" }}
                    onFocus={e => e.target.style.borderColor = C.accent + "88"}
                    onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.09)"}
                  />

                  {/* Sale */}
                  <div style={{ padding: "0.75rem", background: C.green + "08", border: `1px solid ${C.green}18`, borderRadius: 12, marginBottom: "0.85rem" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: saleCorrente.length ? "0.6rem" : 0 }}>
                      <span style={{ fontSize: "0.7rem", color: C.secondary, fontWeight: 500 }}>Sale aggiuntive</span>
                      <button type="button" onClick={() => {
                        const saleAtt = locale.sale || []; const l = String.fromCharCode(65 + saleAtt.length);
                        if (saleAtt.length >= 26) { alert("Max 26 sale"); return; }
                        handleChange(locale.id, "sale", [...saleAtt, { lettera: l, numeroTavoli: "" }]);
                      }} style={{ padding: "0.3rem 0.65rem", background: C.green + "18", border: `1px solid ${C.green}30`, borderRadius: 7, color: C.green, fontSize: "0.7rem", fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
                        + Aggiungi
                      </button>
                    </div>
                    {saleCorrente.map((sala, idx) => (
                      <div key={idx} style={{ display: "flex", alignItems: "center", gap: "0.4rem", padding: "0.4rem 0.55rem", background: "rgba(255,255,255,0.04)", borderRadius: 8, marginBottom: "0.35rem" }}>
                        <span style={{ fontWeight: 600, color: C.green, fontSize: "0.72rem", minWidth: 44 }}>Sala {sala.lettera}</span>
                        <input type="number" value={sala.numeroTavoli} min={1} onChange={e => {
                          const sc = modifiche[locale.id]?.sale || locale.sale || [];
                          const ns = [...sc]; ns[idx] = { ...ns[idx], numeroTavoli: e.target.value === "" ? "" : parseInt(e.target.value) || "" };
                          handleChange(locale.id, "sale", ns);
                        }} style={{ flex: 1, padding: "0.3rem 0.4rem", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 6, color: C.text, fontSize: "0.76rem", outline: "none" }} />
                        <button type="button" onClick={() => { const sc = modifiche[locale.id]?.sale || locale.sale || []; handleChange(locale.id, "sale", sc.filter((_, i) => i !== idx)); }}
                          style={{ padding: "0.28rem 0.45rem", background: C.red + "15", border: `1px solid ${C.red}25`, borderRadius: 6, color: C.red, cursor: "pointer", fontSize: "0.7rem", fontFamily: "inherit" }}>✕</button>
                      </div>
                    ))}
                  </div>

                  <Lbl>Nuovo tag (facoltativo)</Lbl>
                  <input type="text" defaultValue={locale.id} onChange={e => handleChange(locale.id, "nuovoTag", e.target.value)}
                    style={{ ...inp, marginBottom: "0.85rem" }}
                    onFocus={e => e.target.style.borderColor = C.accent + "88"}
                    onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.09)"}
                  />

                  <Lbl>Nuovo logo</Lbl>
                  <input type="file" accept="image/*" onChange={e => handleChange(locale.id, "logoFile", e.target.files[0])}
                    style={{ ...inp, border: "1px dashed rgba(255,255,255,0.12)", cursor: "pointer", marginBottom: "1rem" }} />

                  {/* Actions */}
                  <ActionBtn onClick={() => salvaModifiche(locale.id)} color={C.green} full>Salva modifiche</ActionBtn>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0.5rem", marginTop: "0.5rem" }}>
                    <ActionBtn onClick={() => setModaleAperta(locale.id)} color={C.accent}>
                      <Icons.settings /> Funzioni
                    </ActionBtn>
                    <ActionBtn onClick={() => setModaleAIOpen(locale.id)} color={C.purple}>
                      <Icons.ai /> AI
                    </ActionBtn>
                    <ActionBtn onClick={() => apriModaleColori(locale.id)} color={C.orange}>
                      <Icons.category /> Colori
                    </ActionBtn>
                  </div>
                  <div style={{ marginTop: "0.5rem", display: "grid", gap: "0.5rem" }}>


                    <ActionBtn
                      onClick={() => toggleStatoLocale(locale.id)}
                      color={locale.stato === "bloccato" ? C.green : C.red}
                      full
                    >
                      {locale.stato === "bloccato"
                        ? "🟢 Riattiva locale"
                        : "🚫 Blocca locale"}
                    </ActionBtn>

                    {locale.demo === true && (
                      <ActionBtn
                        onClick={async () => {
                          const demoTerminata =
                            locale.trialExpired === true;

                          const ok = window.confirm(
                            demoTerminata
                              ? "Riattivare questa demo?"
                              : "Terminare anticipatamente questa demo?"
                          );

                          if (!ok) return;

                          try {

                            if (demoTerminata) {

                              await updateDoc(
                                doc(db, "locali", locale.id),
                                {
                                  trialExpired: false,
                                  stato: "attivo",
                                }
                              );

                              setMessaggio(
                                "✅ Demo riattivata"
                              );

                            } else {

                              await updateDoc(
                                doc(db, "locali", locale.id),
                                {
                                  trialExpired: true,
                                  stato: "bloccato",
                                  expiredAt: new Date(),
                                }
                              );

                              setMessaggio(
                                "⛔ Demo terminata"
                              );

                            }

                          } catch (err) {

                            console.error(err);

                            setMessaggio(
                              "❌ Errore gestione demo"
                            );

                          }

                          setTimeout(() => {
                            setMessaggio("");
                          }, 3000);

                        }}
                        color={
                          locale.trialExpired
                            ? C.green
                            : C.orange
                        }
                        full
                      >
                        {locale.trialExpired
                          ? "🟢 Riattiva demo"
                          : "⛔ Termina demo"}
                      </ActionBtn>
                    )}

                    <ActionBtn
                      onClick={() => eliminaLocale(locale.id)}
                      color={C.red}
                      full
                    >
                      Elimina locale
                    </ActionBtn>

                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* ── Modale Funzioni ── */}
      {modaleAperta && (() => {
        const locale = locali.find(l => l.id === modaleAperta);
        if (!locale) return null;
       
        return (
          <Modal onClose={() => setModaleAperta(null)} title="Funzioni locale">
            <p style={{ margin: "0 0 1rem", fontSize: "0.78rem", color: C.secondary }}>{locale.nome || locale.id}</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.45rem" }}>
              {TOGGLES.map(({ key, icon, label, invertito }) => (
                <Toggle key={key} icon={icon} label={label}
                  active={invertito ? !locale[key] : !!locale[key]}
                  onClick={() => toggleImpostazioneLocale(locale.id, key)}
                />
              ))}
         </div>

<div
  style={{
    marginTop: "1.4rem",
    paddingTop: "1.2rem",
    borderTop: "1px solid rgba(255,255,255,0.08)"
  }}
>

<p
  style={{
    margin: "0 0 1rem",
    fontSize: "0.82rem",
    fontWeight: "700",
    color: "#fff"
  }}
>
📦 Limiti del locale
</p>

<div style={{ marginBottom: "1rem" }}>
  <Lbl>Limite piatti</Lbl>

<input
  type="number"
  min="0"
  placeholder="Illimitato"
  value={limitePiatti}
  onChange={(e) => setLimitePiatti(e.target.value)}
  style={inp}
  onFocus={e => e.target.style.borderColor = C.accent + "88"}
  onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.09)"}
/>

<p
  style={{
    marginTop: "0.35rem",
    fontSize: "0.68rem",
    color: C.secondary
  }}
>
Lascia vuoto per illimitato.
</p>
</div>

<div style={{ marginBottom: "1rem" }}>
  <Lbl>Limite camerieri</Lbl>

<input
  type="number"
  min="0"
  placeholder="Illimitato"
  value={limiteCamerieri}
  onChange={(e) => setLimiteCamerieri(e.target.value)}
  style={inp}
  onFocus={e => e.target.style.borderColor = C.accent + "88"}
  onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.09)"}
/>

<p
  style={{
    marginTop: "0.35rem",
    fontSize: "0.68rem",
    color: C.secondary
  }}
>
Lascia vuoto per illimitato.
</p>
</div>

<ActionBtn
  color={C.green}
  full
  onClick={async () => {
    const nuovoLimitePiatti =
      limitePiatti === ""
        ? null
        : Number(limitePiatti);

    const nuovoLimiteCamerieri =
      limiteCamerieri === ""
        ? null
        : Number(limiteCamerieri);

    try {
      await updateDoc(
        doc(db, "locali", locale.id),
        {
          limitePiatti: nuovoLimitePiatti,
          limiteCamerieri: nuovoLimiteCamerieri,
        }
      );

      setLocali(prev =>
        prev.map(l =>
          l.id === locale.id
            ? {
                ...l,
                limitePiatti: nuovoLimitePiatti,
                limiteCamerieri: nuovoLimiteCamerieri,
              }
            : l
        )
      );

      setMessaggio("✅ Limiti aggiornati");
setModaleAperta(null);
      setTimeout(() => {
        setMessaggio("");
      }, 3000);
    } catch (error) {
      console.error("Errore salvataggio limiti:", error);

      setMessaggio("❌ Errore salvataggio limiti");

      setTimeout(() => {
        setMessaggio("");
      }, 3000);
    }
  }}
>
  💾 Salva limiti
</ActionBtn>

</div>

<div style={{ marginTop: "1.1rem" }}>
              <ActionBtn onClick={() => setModaleAperta(null)} color={C.accent} full>Chiudi</ActionBtn>
            </div>
          </Modal>
        );
      })()}

      {/* ── Modale AI ── */}
      {modaleAIOpen && (
        <Modal onClose={() => setModaleAIOpen(null)} title="Impostazioni AI">
          <div style={{ display: "flex", flexDirection: "column", gap: "0.85rem" }}>
            <div><Lbl>Crediti AI immagini</Lbl><input type="number" value={newAiCredits} onChange={e => setNewAiCredits(parseInt(e.target.value))} style={inp} /></div>
            <div><Lbl>AI abilitata</Lbl>
              <select value={aiEnabled ? "true" : "false"} onChange={e => setAiEnabled(e.target.value === "true")} style={{ ...inp, cursor: "pointer" }}>
                <option value="true">Sì</option><option value="false">No</option>
              </select>
            </div>
            <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: "0.85rem" }}>
              <p style={{ margin: "0 0 0.75rem", fontSize: "0.75rem", color: C.secondary, fontWeight: 600 }}>Traduzioni AI</p>
              <div><Lbl>Crediti traduzioni</Lbl><input type="number" value={translationCredits} onChange={e => setTranslationCredits(parseInt(e.target.value) || 0)} style={inp} /></div>
              <div><Lbl>Traduzioni abilitate</Lbl>
                <select value={translationEnabled ? "true" : "false"} onChange={e => setTranslationEnabled(e.target.value === "true")} style={{ ...inp, cursor: "pointer" }}>
                  <option value="true">Sì</option><option value="false">No</option>
                </select>
              </div>
            </div>
            <ActionBtn color={C.accent} full onClick={async () => {
              await setDoc(doc(db, "aiCredits", modaleAIOpen), { credits: newAiCredits, enabled: aiEnabled, maxCreditsAllowed: newAiCredits }, { merge: true });
              await setDoc(doc(db, "restaurants", modaleAIOpen, "ai", "translations"), { translationCredits, enabled: translationEnabled, updatedAt: new Date() }, { merge: true });
              await updateDoc(doc(db, "locali", modaleAIOpen), {
                translationEnabled: translationEnabled
              });
              alert("Crediti AI aggiornati!");
            }}>Salva crediti AI</ActionBtn>
            <ActionBtn onClick={() => setModaleAIOpen(null)} color={C.secondary} full>Chiudi</ActionBtn>
          </div>
        </Modal>
      )}

      {/* ── Modale Colori ── */}
      {modaleColoriAperta && (() => {
        const locale = locali.find(l => l.id === modaleColoriAperta);
        if (!locale) return null;
        return (
          <Modal onClose={() => setModaleColoriAperta(null)} title="Colori menu asporto">
            <p style={{ margin: "0 0 1rem", fontSize: "0.78rem", color: C.secondary }}>{locale.nome || locale.id}</p>
            <ColorField label="Primario" hint="Header e bottoni" val={coloriTemp.primario || "#3E2723"} onChange={v => setColoriTemp(p => ({ ...p, primario: v }))} />
            <ColorField label="Secondario" hint="Accenti" val={coloriTemp.secondario || "#8B4513"} onChange={v => setColoriTemp(p => ({ ...p, secondario: v }))} />
            <ColorField label="Sfondo" hint="Sfondo pagina" val={coloriTemp.sfondo || "#FAEBD7"} onChange={v => setColoriTemp(p => ({ ...p, sfondo: v }))} />
            <ColorField label="Testo" hint="Testo principale" val={coloriTemp.testo || "#3E2723"} onChange={v => setColoriTemp(p => ({ ...p, testo: v }))} />
            {/* Preview */}
            <div style={{ padding: "0.9rem", backgroundColor: coloriTemp.sfondo || "#FAEBD7", borderRadius: 12, border: `1.5px solid ${coloriTemp.primario || "#3E2723"}`, marginBottom: "1.1rem" }}>
              <div style={{ backgroundColor: coloriTemp.primario, color: "#fff", padding: "0.5rem 0.75rem", borderRadius: 8, fontWeight: 600, marginBottom: "0.45rem", fontSize: "0.8rem" }}>Header</div>
              <p style={{ margin: "0.3rem 0", fontSize: "0.76rem", color: coloriTemp.testo }}>Testo di esempio</p>
              <button style={{ backgroundColor: coloriTemp.secondario, color: "#fff", border: "none", padding: "0.38rem 0.75rem", borderRadius: 7, fontWeight: 600, fontSize: "0.73rem", cursor: "pointer" }}>Bottone</button>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem" }}>
              <ActionBtn color={C.green} onClick={() => salvaColori(modaleColoriAperta)} full>Salva</ActionBtn>
              <ActionBtn color={C.orange} onClick={() => resetColori(modaleColoriAperta)} full>Reset</ActionBtn>
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              <ActionBtn onClick={() => setModaleColoriAperta(null)} color={C.secondary} full>Chiudi</ActionBtn>
            </div>
          </Modal>
        );
      })()}
    </div>
  );
}
